export default __webpack_public_path__ + "static/media/octotrends-logo-black.2cd62cde.png";